import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/HeroSection/HeroSection.styles';

const HeroSection: React.FC = () => {
  const content = useContent('AboutUsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  return (
    <StyledBox>
      <Box className="HSBGOverlay" />
      <Box className="HSBGPattern">
        <ImgBox
          image={{
            src: getSizedImage(content.patternBackground),
            alt: content.patternBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Container maxWidth="xl" className="HSContainer">
        <Typography variant="h1" component="h1" className="HSPageTitle">
          {content.heroPageTitle}
        </Typography>
        <Box className="HSContentBox">
          <Grid container spacing={10} className="HSGrid">
            <Grid item xl={6} lg={6} md={12} sm={12} className="HSTextColumn">
              <Box className="HSHeadingContainer">
                <Typography
                  variant="h4"
                  component="h4"
                  className="HSHeadingLine1"
                  textTransform="uppercase">
                  {content.heroHeadingFirst}
                </Typography>
                <Typography
                  variant="h3"
                  component="h3"
                  className="HSHeadingLine2"
                  textTransform="uppercase">
                  {content.heroHeadingSecond}
                </Typography>
              </Box>
              <Typography variant="body1" component="p" className="HSParagraph">
                {content.heroFirstParagraph}
              </Typography>
              <Typography variant="body1" component="p" className="HSParagraph">
                {content.heroSecondParagraph}
              </Typography>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} className="HSImageColumn">
              <ImgBox
                image={{
                  src: getSizedImage(content.heroImage),
                  alt: content.heroImage.alt,
                }}
                imgWidth="100%"
                imgHeight="355px"
                unoptimized
                className="HSHeroImage"
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { HeroSection };
